import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainLayoutComponent } from './global-layout.component';
import { MainMenuComponent } from './main-menu/main-menu.component';
import { RightPanelComponent } from './right-panel/right-panel.component';
import { UniversalNavComponent } from './universal-nav/universal-nav.component';
import { SharedModule } from '../../shared/shared.module';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    MainLayoutComponent,
    MainMenuComponent,
    RightPanelComponent,
    UniversalNavComponent
  ],
  imports: [
    SharedModule,
    CommonModule,
    RouterModule
  ],
  exports: [
    MainLayoutComponent,
    MainMenuComponent,
    RightPanelComponent,
    UniversalNavComponent
  ]
})
export class GlobalLayoutModule { }
